import { useThemeContext } from 'context/ThemeContext';
import { RealmOrigin } from 'types/RealmOrigin';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ReturnType {
  theme: RealmOrigin;
  isStorroTheme: boolean;
  isAgencyTheme: boolean;
  companyName: string;
  guestSingularLabel: string;
  guestPluralLabel: string;
  userSingularLabel: string;
  userPluralLabel: string;
}

/**
 * Small custom hook that detect what kind of theme we are running
 */
function useTheme(): ReturnType {
  const { theme } = useThemeContext();
  const { t } = useTranslation();

  /**
   * Return the correct singular label for the guest based on the theme
   */
  const guestSingularLabel = useMemo((): string => {
    if (theme === RealmOrigin.Storro) {
      return t('guest', 'Guest').toLowerCase();
    }
    return t('partner', 'Partner').toLowerCase();
  }, [t, theme]);

  /**
   * Return the correct plural label for the guest based on the theme
   */
  const guestPluralLabel = useMemo((): string => {
    if (theme === RealmOrigin.Storro) {
      return t('guests', 'Guests').toLowerCase();
    }
    return t('partners', 'Partners').toLowerCase();
  }, [t, theme]);

  /**
   * Return the correct singular label for the user based on the theme
   */
  const userSingularLabel = useMemo((): string => {
    // TODO decide what the label for a user would be
    // if (theme === RealmOrigin.Storro) {
    //   return t('colleague', 'Colleague').toLowerCase();
    // }
    // return t('personnal', 'Personnal').toLowerCase();
    return t('user', 'User').toLowerCase();
  }, [t]);

  /**
   * Return the correct plural label for the user based on the theme
   */
  const userPluralLabel = useMemo((): string => {
    // TODO decide what the label for a user would be
    // if (theme === RealmOrigin.Storro) {
    //   return t('colleagues', 'Colleagues').toLowerCase();
    // }
    // return t('personnal', 'Personnal').toLowerCase();
    return t('users', 'Users').toLowerCase();
  }, [t]);

  return {
    theme,
    isStorroTheme: theme === RealmOrigin.Storro,
    isAgencyTheme: theme === RealmOrigin.AgencyDrive,
    companyName: theme === RealmOrigin.Storro ? 'Storro' : 'Agency Drive',
    guestSingularLabel,
    guestPluralLabel,
    userSingularLabel,
    userPluralLabel,
  };
}

export default useTheme;
